<template>
  <el-row>
    <el-col :span="spanTitle">
      <div class="input-title">色・サイズ</div>
    </el-col>
    <el-col :span="spanSetting">
      <el-button id="button-config-color-size" type="danger" @click="$emit('click')">色・サイズ選択</el-button>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'ColorSizeButton',
  props: {
    spanTitle: {
      type: Number
    },
    spanSetting: {
      type: Number
    }
  }
}
</script>

<style scoped>
div.input-title {
  text-align: end;
  vertical-align: middle;
  margin-top: 5px;
  margin-right: 10px;
}
button.el-button {
  display: block;
  width: 100%;
}
</style>
